function initHeader() {
  const header = document.querySelector('.section-header');
  if(!header) return;

  handleMenuTriggers(header);

  window.addEventListener('scroll', () => {
    handleHeaderScroll(header);
  });
}

function handleMenuTriggers(header) {
  const triggers = header.querySelectorAll('[data-trigger-menu]');
  const navigation = header.querySelector('[data-navigation]');
  if(!triggers || !navigation) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      navigation.classList.toggle('open');
      if(navigation.classList.contains('open')) {
        document.querySelector('html').style.overflow = "hidden";
      } else {
        document.querySelector('html').removeAttribute('style');
      }
    });
  });
}

function handleHeaderScroll(header) {
  if(window.scrollY > 10 && !header.classList.contains('scrolled')) {
    header.classList.add('scrolled');
  }

  if(window.scrollY < 10 && header.classList.contains('scrolled')) {
    header.classList.remove('scrolled');
  }
}

window.addEventListener('load', () => {
  initHeader();
});